var React = require('react');

function Players (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#sa11y9f6fa)","key":0},React.createElement("path",{"d":"M12.87 1c-.613 1.188-1.759 1.99-3.072 1.99-1.314 0-2.46-.802-3.072-1.99L1 3.455l.61 4.214h2.715v11.067c0 .146.106.264.236.264h10.473c.13 0 .236-.118.236-.264V7.67h2.716l.61-4.214L12.868 1z","stroke":"var(--navIconColor)","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"sa11y9f6fa"},React.createElement("path",{"fill":"var(--navIconColor)","d":"M0 0h20v20H0z"})))]);
}

Players.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Players;

Players.default = Players;
